/* Visible-only muted playback, including dynamically cloned mountain cards. */
(() => {
  if (window.nkWorksVideoInstalled) return;
  window.nkWorksVideoInstalled = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const pausedScopes = new WeakMap();
  const scopeOf = video => video.closest('[data-work-video-scope]');
  const isPaused = scope => pausedScopes.get(scope) ?? reduced.matches;
  const sync = video => {
    const state = states.get(video);
    if (!state) return;
    const scope = scopeOf(video);
    if (!state.visible || document.hidden || isPaused(scope) || video.closest('[hidden]') || state.failed) {
      video.pause(); return;
    }
    if (!state.loaded) {
      video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      state.loaded = true;
      video.load();
    }
    video.muted = true;
    if (video.paused && !state.pending) {
      state.pending = true;
      const peer = [...states.keys()].find(other => other !== video && other.dataset.videoKey === video.dataset.videoKey && !other.paused);
      if (peer && video.readyState > 0) video.currentTime = peer.currentTime;
      video.play().then(() => {
        state.pending = false;
        if (!state.visible || document.hidden || isPaused(scope)) video.pause();
      }).catch(() => {
        state.pending = false;
        // Autoplay can be blocked by device policy. Keep the poster.
        pausedScopes.set(scope, true);
        states.forEach((_, other) => { if (scopeOf(other) === scope) other.pause(); });
      });
    }
  };
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const state = states.get(entry.target);
    if (state) { state.visible = entry.isIntersecting && entry.intersectionRatio > 0; sync(entry.target); }
  }), {threshold: [0, .01]});
  const scan = () => {
    states.forEach((_, video) => {
      if (!video.isConnected) { video.pause(); observer.unobserve(video); states.delete(video); }
    });
    document.querySelectorAll('[data-work-video]').forEach(video => {
      if (states.has(video)) return;
      // Clones can inherit loaded sources; restore lazy loading before observing them.
      video.querySelectorAll('source[data-src]').forEach(source => source.removeAttribute('src'));
      video.muted = true;
      states.set(video, {visible:false, loaded:false, pending:false, failed:false});
      video.addEventListener('error', () => {
        const state = states.get(video);
        if (state) { state.failed = true; video.pause(); }
      });
      observer.observe(video);
    });
  };
  document.addEventListener('visibilitychange', () => states.forEach((_, video) => sync(video)));
  reduced.addEventListener('change', () => {
    document.querySelectorAll('[data-work-video-scope]').forEach(scope => pausedScopes.delete(scope));
    states.forEach((_, video) => sync(video));
  });
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1))) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; scan(); });
  }).observe(document.body, {childList:true, subtree:true});
  scan();
})();
